export default __webpack_public_path__ + "static/media/ArtificialIntelligence_InformedSearch.2eeb0be9.zip";